// extracted by mini-css-extract-plugin
export default {"sectionTitle":"PSYT7___Navigation-module__sectionTitle","navigation":"qltcp___Navigation-module__navigation"};